import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "android"
const AndroidIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.043 19.29C18.103 19.405 18.121 19.523 18.105 19.633Q18.092 19.717 18.056 19.792C17.94 20.038 17.646 20.196 17.342 20.078L12 18 6.658 20.078C6.218 20.248 5.8 19.841 5.907 19.42Q5.923 19.355 5.957 19.29L12 7.875z" />
          <path d="M11.016 3.619C11.444 2.845 12.555 2.845 12.984 3.619L19.906 16.143C20.32 16.893 19.778 17.813 18.92 17.813H18.11L17.514 16.688H18.921L12 4.163 5.079 16.688H6.486L5.89 17.813H5.079C4.222 17.813 3.679 16.893 4.094 16.143z" />
        </svg>
      }
    </span>
  )
}
export default AndroidIcon
